import Api from "../../config/ApiConfig";
import * as types from "./types";
import * as functions from '../../components/shared/functions';

const apiUrls = {
    getPatterns: "api/v1/patterns",
    postCustExt: "api/v1/extractors/custom",
    postDbExt: "api/v1/extractors/db",
    getDataExtractorList: "api/v1/searches/extractors",
    getExtractorDetail: "api/v1/extractors",
    putExtractor: "api/v1/extractors",

}

export const getPatterns = (params: types.IPatternParams) =>
    Api.get(apiUrls.getPatterns + `?layerType=${params.layerType}&sourceId=${params.sourceId}`)
        .then((response) => { return response })
        .catch((error) => { return error.response });

export const postCustExtractor = (payload: types.ICustomExtParams) =>
    Api.post(apiUrls.postCustExt, payload)
        .then((response) => { return response; })
        .catch((error) => { return error.response; });

export const postMetaDataDBExtractor = (payload: types.IDBExtParams) =>
    Api.post(apiUrls.postDbExt, payload)
        .then((response) => { return response; })
        .catch((error) => { return error.response; });

export const getDataExtractorList = (params: types.IExtractorListParams) =>
    Api.get<types.IDataExtractor[]>(apiUrls.getDataExtractorList + "?skip=" + params.skip + "&count=" + params.count + "&orderby=" + params.orderby + "&top=" + params.top + "&queryType=full&search=" + params.search +
        functions.getParam(params.schema, "schema") + functions.getParam(params.table, "table") + functions.getParam(params.treatmentLevel, "treatmentLevel") + functions.getParam(params.sourceName, "sourceName")
        + functions.getParam(params.dataStewards, "dataStewards") + functions.getParam(params.spokeName, "spokeName") + functions.getParam(params.accessControl, "accessControl") + functions.getBooleanParam(params.nonUdlTables, "non_udl_tables")) 
        .then((response) => { return response; })
        .catch((error) => { return error.response; });

export const getExtractorDetail = (params: string) =>
    Api.get(apiUrls.getExtractorDetail + `/${params}`)
        .then((response) => { return response })
        .catch((error) => { return error.response });

export const deleteExtractor = (payload: types.IDeleteParams) =>
    Api.delete(apiUrls.getExtractorDetail, { data: payload })
        .then((response) => { return response })
        .catch((error) => { return error.response });

export const editExtractor = (param: string, payload: types.IExtractorPutReq) =>
    Api.put(apiUrls.putExtractor + `/${param}`, payload)
        .then((response) => { return response })
        .catch((error) => { return error.response });

export const getExtractorStatus = (params: string) =>
    Api.get(`${apiUrls.getExtractorDetail}/${params}/status`)
        .then((response) => { return response })
        .catch((error) => { return error.response });

export const editSchemaExt = (param: string, payload: types.ISchemaExtReq) =>
    Api.post(`${apiUrls.putExtractor}/${param}/actions/updateSchema`, payload)
        .then((response) => { return response })
        .catch((error) => { return error.response });

export const retrySchemaUpdate = (batchCode: string, forceValue: boolean) =>
    Api.post(`${apiUrls.putExtractor}/${batchCode}/actions/retryUpdateSchema?force=${forceValue}`)
        .then((response) => { return response })
        .catch((error) => { return error.response });          